// extracted by mini-css-extract-plugin
export default {"RMSBreadcrumb":"RMSBreadcrumb_RMSBreadcrumb__Rj+dn"};